import React, { useState } from "react";
import "./PAMMClients.css";
import { Eye, Edit, User } from "lucide-react";

function PAMMClients() {
  const [clients] = useState([
    { id: 1, name: "John Doe", email: "john@example.com", phone: "+1234567890", country: "USA", status: "Active", investedAmount: "$10,000", joinDate: "2025-01-15" },
    { id: 2, name: "Jane Smith", email: "jane@example.com", phone: "+0987654321", country: "UK", status: "Active", investedAmount: "$25,000", joinDate: "2025-02-20" },
    { id: 3, name: "Mike Johnson", email: "mike@example.com", phone: "+1122334455", country: "Canada", status: "Inactive", investedAmount: "$5,000", joinDate: "2025-03-10" },
  ]);

  return (
    <div className="pamm-clients-container">
      {/* Page Header */}
      <div className="page-header">
        <div className="header-left">
          <h1>Total PAMM Clients</h1>
          <div className="header-bottom">
            <h2 className="view-all">View all PAMM clients</h2>
          </div>
        </div>
        <div className="header-right">
          <button className="btn create-btn">+ Add New Client</button>
          <button className="btn orange">Export Data</button>
        </div>
      </div>

      {/* Filters Section */}
      <div className="filters">
        <input type="text" placeholder="Search by Client Name, Email, Phone, Country" />
        <button className="btn">Reset Filters</button>
      </div>

      {/* Filter Row */}
      <div className="filter-row">
        <select>
          <option>Status</option>
          <option>Active</option>
          <option>Inactive</option>
        </select>
        <select>
          <option>Country</option>
          <option>USA</option>
          <option>UK</option>
          <option>Canada</option>
        </select>
        <input type="date" placeholder="Start Date" />
        <input type="date" placeholder="End Date" />
        <button className="btn">Export to Excel</button>
      </div>

      {/* Table */}
      <div className="table-container">
        <table className="pamm-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Full Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Country</th>
              <th>Invested Amount</th>
              <th>Status</th>
              <th>Join Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((client, index) => (
              <tr key={client.id}>
                <td>{index + 1}</td>
                <td>{client.name}</td>
                <td>{client.email}</td>
                <td>{client.phone}</td>
                <td>{client.country}</td>
                <td>{client.investedAmount}</td>
                <td>
                  <span className={`status ${client.status === "Active" ? "success" : "warning"}`}>
                    {client.status}
                  </span>
                </td>
                <td>{client.joinDate}</td>
                <td>
                  <button className="icon-btn" title="View">
                    <Eye size={18} />
                  </button>
                  <button className="icon-btn" title="Edit">
                    <Edit size={18} />
                  </button>
                  <button className="icon-btn" title="Profile">
                    <User size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>Copyright © 2025 <span className="brand">Vista FX Solutions</span>. All rights reserved.</p>
        <span className="version">Version 2.0</span>
      </footer>
    </div>
  );
}

export default PAMMClients;
